if (!customElements.get('caene-video-reels')) {
  customElements.define('caene-video-reels', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const controller = new AbortController();
      const { signal } = controller;
      const track = this.querySelector('.cr__track');
      const previous = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (!track || !previous || !next) return;
      const videos = [...this.querySelectorAll('video')];
      const autoplay = this.classList.contains('cr--pdp');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const visible = new Set();
      const manuallyPaused = new Set();
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = (direction) => {
        const card = track.querySelector('.cr__card');
        if (!card) return;
        const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({left: direction * distance, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
      };
      const updatePlayback = video => {
        const button = video.parentElement.querySelector('[data-playback]');
        if (!button) return;
        const paused = video.paused;
        button.textContent = paused ? 'Play' : 'Pause';
        button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        button.classList.toggle('is-playing', !paused);
      };
      const play = video => {
        video.muted = true;
        const pending = video.play();
        // Low power mode or browser autoplay policy may reject playback.
        // Keep the poster and a working manual play control in that case.
        pending?.catch(() => updatePlayback(video));
      };
      const sync = () => videos.forEach(video => {
        if (autoplay && visible.has(video) && !document.hidden && !reducedMotion.matches && !manuallyPaused.has(video)) play(video);
        else if (autoplay) video.pause();
      });
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {signal, passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      videos.forEach(video => {
        video.addEventListener('play', () => {
          if (!autoplay) videos.forEach(other => { if (other !== video) other.pause(); });
          updatePlayback(video);
        }, {signal});
        video.addEventListener('pause', () => updatePlayback(video), {signal});
        const button = video.parentElement.querySelector('[data-playback]');
        if (autoplay && button) { video.controls = false; button.hidden = false; }
        button?.addEventListener('click', () => {
          if (video.paused) { manuallyPaused.delete(video); play(video); }
          else { manuallyPaused.add(video); video.pause(); }
        }, {signal});
      });
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) visible.add(entry.target);
          else { visible.delete(entry.target); entry.target.pause(); }
        });
        if (autoplay) sync();
      }, {threshold:[0,0.5]});
      videos.forEach(video => observer.observe(video));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) videos.forEach(video => video.pause());
        else sync();
      }, {signal});
      reducedMotion.addEventListener('change', sync, {signal});
      const resize = new ResizeObserver(update); resize.observe(track); update();
      this.cleanup = () => {controller.abort();observer.disconnect();resize.disconnect();videos.forEach(video => video.pause());};
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
